"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _helpers = require("../../../helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Aside = _styledComponents.default.aside.withConfig({
  displayName: "Aside",
  componentId: "sc-15gp4qp-0"
})(["width:100%;margin-bottom:24px;@media ", "{width:320px;}"], (0, _helpers.breakpoint)('minDesktop'));

var _default = Aside;
exports.default = _default;